import SortableHeaderCellRenderer from './SortableHeaderCellRenderer';

export default SortableHeaderCellRenderer;
